module.exports = __webpack_public_path__ + "c905f6e41fa694eb49f547ce421d63bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/accessory-detail-content/icon_link_dark.png
// module id = 881
// module chunks = 0 1